import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessagesService {
  private validationMessagesSubject = new BehaviorSubject<string[]>([]);
  validationMessages$: Observable<string[]> =
    this.validationMessagesSubject.asObservable();

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.clearErrors();
      });
  }

  addError(message: string): void {
    this.addErrors([message]);
  }

  /** Adds messages not already shown, so repeated failures don't stack up. */
  addErrors(messages: string[]): void {
    const currentMessages = this.validationMessagesSubject.value;
    const newMessages = messages.filter(
      (message, index) =>
        !currentMessages.includes(message) &&
        messages.indexOf(message) === index,
    );
    if (!newMessages.length) return;
    this.validationMessagesSubject.next([...currentMessages, ...newMessages]);
  }

  clearErrors(): void {
    this.validationMessagesSubject.next([]);
  }

  getErrors(): string[] {
    return this.validationMessagesSubject.value;
  }
}
